<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import i18nFilter from "@/filters/i18n.filter";
import errors from "@/utils/errors";

import MainLayout from "@/layouts/MainLayout.vue";
import AuthLayout from "@/layouts/AuthLayout.vue";

export default {
  components: { MainLayout, AuthLayout },

  computed: {
    layout() {
      return (this.$route.meta.layout || "auth") + "-layout";
    },
    ...mapGetters(["error"])
  },

  watch: {
    $route({ query: { msg } }) {
      if (msg) this.$toasted.show(decodeURIComponent(msg));
    },
    error(err) {
      if (err != null) {
        // Handle Firebase Auth Errors
        if (err.code) {
          this.$toasted.show(i18nFilter(errors[err.code]));
        } else {
          this.$toasted.show(
            errors[err] ? i18nFilter(errors[err]) : i18nFilter(errors.default)
          );
        }
        this.clearError();
      }
    }
  },

  beforeDestroy() {
    this.clearError();
  },

  methods: {
    ...mapMutations(["clearError"])
  }
};
</script>
